import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faTwitterSquare,
  faInstagramSquare,
  faLinkedin,
  faYoutubeSquare,
} from "@fortawesome/free-brands-svg-icons";
import "../styles/footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-main">
        <div className="footer-contact">
          <p className="kc-div">
            Khayrallah Center for Lebanese Diaspora Studies
          </p>
          <div className="address-div">
            Campus Box 8013 <br />
            North Carolina State University <br />
            Raleigh, NC 27695-8108 <br />
            919.515.5058 <br />{" "}
            <a href="mailto:lebanesestudies@ncsu.edu" className="red-link">
              lebanesestudies@ncsu.edu
            </a>
          </div>
        </div>

        <nav className="footer-links" aria-label="Explore">
          <h2>Explore</h2>
          <a href="/browse-periodicals">Periodicals</a>
          <a href="/browse-books">Books</a>
          <a href="/browse-periodicals">Collections</a>
        </nav>

        <nav className="footer-links" aria-label="About">
          <h2>About</h2>
          <a href="/learn-more">Our Mission</a>
          <a href="mailto:lebanesestudies@ncsu.edu">Contact</a>
          <a href="/faq">FAQ</a>
        </nav>
      </div>

      <div className="footer-bottom">
        <div className="social-media-icons social-media-div">
          <a href="https://www.facebook.com/KhayrallahCenter" data-ua-label="Facebook" aria-label="Facebook">
            <FontAwesomeIcon icon={faFacebookSquare} className="social-media-icon" />
          </a>

          <a href="https://twitter.com/KhayrallahNCSU" data-ua-label="Twitter" aria-label="Twitter">
            <FontAwesomeIcon icon={faTwitterSquare} className="social-media-icon" />
          </a>

          <a href="https://www.instagram.com/khayrallahcenter/" data-ua-label="Instagram" aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagramSquare} className="social-media-icon" />
          </a>

          <a
            href="https://www.linkedin.com/in/khayrallah-center-for-lebanese-diaspora-studies/"
            data-ua-label="LinkedIN"
            aria-label="LinkedIn"
          >
            <FontAwesomeIcon icon={faLinkedin} className="social-media-icon" />
          </a>

          <a href="https://www.youtube.com/@LebaneseNC" data-ua-label="Youtube" aria-label="Youtube">
            <FontAwesomeIcon icon={faYoutubeSquare} className="social-media-icon" />
          </a>
        </div>

        <div className="copyright-div">
          <div>
            Copyright © 2023 NC State University. All rights reserved.{" "}
            &nbsp;&nbsp;
            <a href="https://www.ncsu.edu/privacy/" className="red-link">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
